<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetCustom',
  components: {widgetWrapper},
  emits: ['more'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, more, info} = items;
    const widgetWrapper = resolveComponent('widget-wrapper');

    const widgetCustom = h('div', {class: 'widget-custom'}, [this.$slots.wbody()]);

    return h(
        widgetWrapper,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetCustom],
    );
  },
  methods: {},
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-custom {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  white-space: pre;
  @include font(16px);
}
</style>
